import intl from 'react-intl-universal';

// 类目 分类【roomIncome房费, goodsIncome商品, valueAdd增值, memberCard会员卡】
export enum categoryTypeEnum {
  roomIncome = 'roomIncome',
  goodsIncome = 'goodsIncome',
  valueAdd = 'valueAdd',
  memberCard = 'memberCard',
}
export const categoryTypeMap = {
  roomIncome: intl.get('bill_invoice_modal_room_fee'),
  goodsIncome: intl.get('bill_invoice_modal_goods'),
  valueAdd: intl.get('bill_invoice_modal_value_add'),
  memberCard: intl.get('bill_invoice_modal_vip_card'),
};
export const categoryTypeMapForIcon = {
  roomIncome: 'icon-fangfei',
  goodsIncome: 'icon-shangpin',
  valueAdd: 'icon-zengzhi',
  memberCard: 'icon-huiyuan1',
};

// 添加开票订单类型
export enum InvoiceOrderTypeEnum {
  room = 'room', // 房间开票订单
  other = 'other', // 其他开票订单
}

// 订单类型
// reservationOrder房间订单，receptionConsume增值业务订单，receptionGoods商品直售订单，goodsSelfService自助点餐订单，memberCard会员卡订单
export enum OrderTypeEnum {
  reservationOrder = 'reservationOrder',
  receptionConsume = 'receptionConsume',
  receptionGoods = 'receptionGoods',
  goodsSelfService = 'goodsSelfService',
  memberCard = 'memberCard',
}

export const orderTypeMap = {
  reservationOrder: intl.get('bill_invoice_modal_room_order'),
  receptionConsume: intl.get('bill_invoice_modal_reception_consume'),
  receptionGoods: intl.get('bill_invoice_modal_reception_goods'),
  goodsSelfService: intl.get('bill_invoice_modal_goods_self_service'),
  memberCard: intl.get('bill_invoice_modal_vip_card_order'),
};

export const orderTypeOptions = [
  {
    value: OrderTypeEnum.reservationOrder,
    label: intl.get('bill_invoice_modal_room_order'),
  },
  {
    value: OrderTypeEnum.receptionConsume,
    label: intl.get('bill_invoice_modal_reception_consume'),
  },
  {
    value: OrderTypeEnum.receptionGoods,
    label: intl.get('bill_invoice_modal_reception_goods'),
  },
  {
    value: OrderTypeEnum.goodsSelfService,
    label: intl.get('bill_invoice_modal_goods_self_service'),
  },
  {
    value: OrderTypeEnum.memberCard,
    label: intl.get('bill_invoice_modal_vip_card_order'),
  },
];

export const OtherOrderTypeOptions = orderTypeOptions.slice(1, 5);

// 发票类型【11增值税专用发票 12增值税电子专用发票 13增值税电子专用发票(数电) 21增值税普通发票 22增值税电子普通发票 23增值税电子普通发票(数电)】
export const invoiceTypeMap = {
  22: intl.get('bill_invoice_history_invoice_type_text_five'),
  12: intl.get('bill_invoice_history_invoice_type_text_two'),
  21: intl.get('bill_invoice_history_invoice_type_text_four'),
  11: intl.get('bill_invoice_history_invoice_type_text_one'),
  23: intl.get('bill_invoice_history_invoice_type_text_six'),
  13: intl.get('bill_invoice_history_invoice_type_text_three'),
};
// 发票类型 options
export const invoiceTypeOptions = [
  {
    value: '22',
    label: intl.get('bill_invoice_history_invoice_type_text_five'),
  },
  {
    value: '12',
    label: intl.get('bill_invoice_history_invoice_type_text_two'),
  },
  {
    value: '21',
    label: intl.get('bill_invoice_history_invoice_type_text_four'),
  },
  {
    value: '11',
    label: intl.get('bill_invoice_history_invoice_type_text_one'),
  },
  {
    value: '23',
    label: intl.get('bill_invoice_history_invoice_type_text_six'),
  },
  {
    value: '13',
    label: intl.get('bill_invoice_history_invoice_type_text_three'),
  },
];
